import { ListGroup, ListGroupItem } from 'react-bootstrap';

import Text from '../generic/Text';

type CliLicenseScannedMatchesProps = {
  licenseMatchJson: string;
};

type CliLicenseScannedLicenseMatch = {
  licenseId: string;
  matchString: string;
  startLine: number;
  endLine: number;
};

// Example licenseMatch: {"licenseId":"MIT","matchString":"MIT license","startLine":22,"endLine":22}
const renderLicenseGroupMatch = (licenseMatch: CliLicenseScannedLicenseMatch, index: number) => {
  const lineExplanation = licenseMatch.startLine === licenseMatch.endLine ?
    `line ${licenseMatch.startLine}`
    :
    `lines ${licenseMatch.startLine} - ${licenseMatch.endLine}`;

  return (
    <ListGroupItem key={`cli-license-scan-match-${index}`}>
      <p>Match to {licenseMatch.licenseId} License found on {lineExplanation}</p>
      <pre>{licenseMatch.matchString}</pre>
    </ListGroupItem>
  );
};

const CliLicenseScannedMatches = ({
  licenseMatchJson,
}: CliLicenseScannedMatchesProps) => {
  try {
    const matches: CliLicenseScannedLicenseMatch[] = JSON.parse(licenseMatchJson)
      .sort((a: CliLicenseScannedLicenseMatch, b: CliLicenseScannedLicenseMatch) => a.startLine - b.startLine);
    return (
      <ListGroup style={{ overflow: 'scroll', height: 'auto', maxHeight: '100%' }}>
        {matches.map((matcher, i) => renderLicenseGroupMatch(matcher, i))}
      </ListGroup>
    );
  } catch (err) {
    return (
      <div className="padded padded-small">
        <Text.Paragraph>
          An error occurred while displaying this file. Please reload the page and try again in a few minutes.
        </Text.Paragraph>
      </div>
    );
  }
};

export default CliLicenseScannedMatches;
